import dotProp from 'dot-prop-immutable'

import { parsePage } from 'apps/profile/models/Page/adapter'

import {
  fetchInactiveAccounts,
  fetchMessageTagAnalytics,
  fetchPages,
  makeAccountFavorite,
  makeAccountHidden,
  searchPages,
  setUserMenuVisibility,
  sortPages,
} from '../actions/profileActions'

const initialState = {
  pages: {
    initial: [],
    filtered: [],
    loading: false,
    fetched: false,
    error: false,
  },
  userMenuOpened: false,
  messageTagAnalytics: {
    isLoading: false,
    accounts: [],
  },
  inactiveAccountIds: [],
}

export default function profileReducer(state = initialState, action) {
  switch (action.type) {
    case fetchPages.pending.type: {
      return { ...state, pages: { ...state.pages, loading: true, error: false } }
    }
    case fetchPages.fulfilled.type: {
      const pages = action.payload.map(parsePage)

      return {
        ...state,
        pages: {
          ...state.pages,
          initial: pages,
          filtered: [...pages],
          loading: false,
          fetched: true,
        },
      }
    }
    case sortPages.type: {
      const { sortFunction, reset } = action.payload
      const pages = { ...state.pages }

      if (reset) {
        const filteredPagesIds = state.pages.filtered.map((page) => page.id)

        pages.filtered = pages.initial.filter((page) => filteredPagesIds.indexOf(page.id) >= 0)
      } else {
        pages.filtered = pages.filtered.sort(sortFunction)
      }

      return { ...state, pages }
    }
    case searchPages.type: {
      const query = action.payload.toUpperCase()

      return {
        ...state,
        pages: {
          ...state.pages,
          filtered: state.pages.initial.filter(
            (page) => page.name.toUpperCase().indexOf(query) >= 0,
          ),
        },
      }
    }
    case fetchMessageTagAnalytics.pending.type: {
      return {
        ...state,
        messageTagAnalytics: {
          isLoading: true,
          accounts: [],
        },
      }
    }
    case fetchMessageTagAnalytics.fulfilled.type: {
      const { lastAvailableDate, analyticsDateFrom, accounts } = action.payload

      return {
        ...state,
        messageTagAnalytics: {
          isLoading: false,
          lastAvailableDate,
          analyticsDateFrom,
          accounts,
        },
      }
    }
    case fetchMessageTagAnalytics.rejected.type: {
      return {
        ...state,
        messageTagAnalytics: {
          isLoading: true,
        },
      }
    }
    case setUserMenuVisibility.type: {
      return {
        ...state,
        userMenuOpened: action.payload,
      }
    }
    case fetchInactiveAccounts.fulfilled.type: {
      return {
        ...state,
        inactiveAccountIds: action.payload,
      }
    }
    case fetchInactiveAccounts.rejected.type: {
      return {
        ...state,
        inactiveAccountIds: [],
        pages: {
          ...state.pages,
          loading: false,
        },
      }
    }
  }

  state = accountFavoriteReducer(state, action)

  return state
}

const accountFavoriteReducer = (state, action) => {
  const changeInList = (listName, field, value) => {
    const pageId = action.meta.arg.accountId
    const index = state.pages[listName].findIndex((page) => page.id === pageId)
    if (index >= 0) {
      state = dotProp.set(state, `pages.${listName}.${index}.${field}`, value)
    }
  }

  switch (action.type) {
    case makeAccountFavorite.fulfilled.type: {
      const isFavorite = action.payload.is_favorite
      changeInList('initial', 'isFavorite', isFavorite)
      changeInList('filtered', 'isFavorite', isFavorite)
      break
    }
    case makeAccountHidden.fulfilled.type: {
      const isHidden = action.payload.is_hidden
      changeInList('initial', 'isHidden', isHidden)
      changeInList('filtered', 'isHidden', isHidden)
    }
  }

  return state
}
